import styled from 'styled-components';

const BrandBackground = styled.div({
  backgroundColor: '#04324F',
  height: '100%',
  width: '100%',
});

export { BrandBackground };
